var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Fees\n    ")]),_c('student-type-panel-fee',{attrs:{"item":_vm.item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }